import { ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

export const COLORS = {
  videoExpertBackground: 'blue-900',
  audioExpertBackground: 'green-500',
};

export const BADGES = {
  premiumExpert: {
    label: 'Premium Expert',
    className: COLORS.videoExpertBackground,
  },
  platinumExpert: {
    label: 'Platinum Expert',
    className: COLORS.videoExpertBackground,
  },
};

export const EXPERTISE_MAPPING = {
  '655770001': {
    audio: 'premiumAudioExpert',
    video: 'premiumVideoExpert',
    general: 'premiumExpert',
    priority: 2,
  },
  '655770000': {
    audio: 'platinumAudioExpert',
    video: 'platinumVideoExpert',
    general: 'platinumExpert',
    priority: 1,
  },
} as const;

// TODO: Remove after Certified tier is cleaned up in database
export const OBSOLETE_CERTIFIED_ID = '655770002';

export type ExpertiseImageFields = {
  premiumVideoExpertImage: ImageField;
  platinumVideoExpertImage: ImageField;
  premiumAudioExpertImage: ImageField;
  platinumAudioExpertImage: ImageField;
};

export type ExpertiseOption = {
  id: string;
  type: 'audio' | 'video' | null;
  label: string;
  value: string;
};

export type ExpertiseBadgeColors = {
  premiumExpert?: string;
  platinumExpert?: string;
};
